import type { BlogArticleAuthorAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import BlogArticleQ from './BlogArticleQ'
import {
  type AssociationDefinitions,
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryLimitToSQL,
  queryOrderToSQL,
} from './common'
import UserQ from './UserQ'

const BlogArticleAuthorQ = {
  ...makeQueryModelV2<BlogArticleAuthorAttributes>('blog_article_author')([
    'id',
    'blog_article_id',
    'user_id',
    'created_at',
    'updated_at',
    'deleted_at',
  ]),

  associations: (): AssociationDefinitions => ({
    BlogArticle: {
      query: BlogArticleQ,
      foreignKey: BlogArticleQ.id,
      sourceKey: BlogArticleAuthorQ.blog_article_id,
    },
    User: {
      query: UserQ,
      foreignKey: UserQ.id,
      sourceKey: BlogArticleAuthorQ.user_id,
    },
  }),

  where: (
    {
      id,
      blogArticleId,
      userId,
      groupBy = null,
      include = [],
      order = null,
      limit = null,
      paranoid = true,
    }: {
      id?: number | null | SQLFragment<number>
      blogArticleId?: number | null | SQLFragment<number>
      userId?: number | null | SQLFragment<number>
      groupBy?: GroupBy | null
      order?: QueryOrder | null
      include?: IncludeAssociations
      limit?: number | null
      paranoid?: boolean
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<BlogArticleAuthorAttributes> => SQL`
        FROM ${BlogArticleAuthorQ}
        ${includeAssociationsToSql(BlogArticleAuthorQ, include)}
        WHERE
            ${id != null ? SQL`${BlogArticleAuthorQ.id} = ${id} AND` : SQL``}
            ${
              blogArticleId != null
                ? SQL`${BlogArticleAuthorQ.blog_article_id} = ${blogArticleId} AND`
                : SQL``
            }
            ${userId != null ? SQL`${BlogArticleAuthorQ.user_id} = ${userId} AND` : SQL``}
            ${paranoid ? SQL`${BlogArticleAuthorQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
        ${queryLimitToSQL(limit)}
    `,
}

export default BlogArticleAuthorQ
